import { fetchFromContador } from "./contador-fetch.ts";
import type { GResponse } from "../../models/common.ts";
import type { BankAccount } from "../../models/contador.ts";
import type { BankAccountsSearchRequest } from "../../models/search";

type BankAccountPatch = Partial<Pick<BankAccount, "proper_scope" | "is_corporate">> &
    Record<string, unknown>;

export async function patchBankAccount(
    bankAccountId: string,
    payload: BankAccountPatch,
): Promise<BankAccount | undefined> {
    try {
        return await fetchFromContador<BankAccount>(`/api/v1/bank_accounts/${bankAccountId}`, {
            method: "PATCH",
            body: JSON.stringify(payload),
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export async function bulkSetBankAccountProperScope(
    customerId: string,
    enabled: boolean,
    bankAccountIds: string[],
): Promise<void> {
    await fetchFromContador(`/api/v1/customers/${customerId}/bank_accounts/proper-scope`, {
        method: "PATCH",
        body: JSON.stringify({ enabled, bank_account_ids: bankAccountIds }),
    });
}

export async function searchBankAccountsV2(
    payload: BankAccountsSearchRequest,
): Promise<GResponse<BankAccount> | undefined> {
    try {
        return await fetchFromContador<GResponse<BankAccount>>("/api/v2/bank_accounts/search", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
        });
    } catch (e) {
        console.error(e);
        return undefined;
    }
}
